// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg-hover[data-v-037d45e4]:hover{background-color:#f7f7f7}[data-v-037d45e4]::-webkit-scrollbar{display:none}.pair-unpair-button[data-v-037d45e4]{border-radius:8px}@media screen and (max-width:960px){.pair-unpair-button[data-v-037d45e4]{border-radius:0;bottom:0;left:0;min-height:75px;position:fixed;text-transform:none;z-index:10}}.available-channels[data-v-037d45e4]{width:450px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
